export function getTenantDisplayName(tenantId: string, organizationName: string) {
    const tenantIdUpperCase = tenantId.toUpperCase();
    const organizationNameUpperCase = organizationName.toUpperCase();

    if (tenantIdUpperCase.startsWith(organizationNameUpperCase) && tenantIdUpperCase !== organizationNameUpperCase)
        return tenantIdUpperCase.substring(organizationNameUpperCase.length + 1);

    return tenantIdUpperCase;
}

export function getTenantPath(tenantId: string, organizationName: string) {
    const tenantDisplayName = tenantId.toUpperCase() !== organizationName.toUpperCase() && getTenantDisplayName(tenantId, organizationName);

    return [organizationName, tenantDisplayName].filter(Boolean).join('/').toLowerCase();
}
